const truncate = (text, maxCharacters = 25) =>
  text && text.length > maxCharacters
    ? `${text.substring(0, maxCharacters)}…`
    : text;

export default truncate;
